import { createUseStyles } from 'react-jss';
import { color, radius, spacing } from '@blink/components';

export const useManageSectionStyle = createUseStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
        gap: spacing['05'],
        marginTop: 32,
    },
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: spacing['05'],
        alignSelf: 'stretch',
    },
    manage: {
        display: 'flex',
        width: '592px',
        minWidth: '496px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.opaque}`,
        background: color.background.primary,
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: spacing['05'],
        flex: '1 0 0',
        alignSelf: 'stretch',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing['05'],
        alignSelf: 'stretch',
    },
    content: {
        display: 'flex',
        padding: `${spacing['07']} ${spacing['08']} ${spacing['07']} ${spacing['07']}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        alignSelf: 'stretch',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.opaque}`,
    },
    title: {
        color: color.content.primary,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '-0.6px',
    },
    description: {
        color: color.content.secondary,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.48px',
    },
    item: {
        display: 'flex',
        padding: spacing['05'],
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: spacing['04'],
        flex: '1 0 0',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.opaque}`,
    },
    label: {
        color: color.content.fourth,
        fontFeatureSettings: "'calt' off",
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.42px',
    },
    value: {
        color: color.content.primary,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '-0.6px',
    },
    formHeader: {
        display: 'flex',
        padding: `${spacing['05']} ${spacing['07']} ${spacing['03']} ${spacing['07']}`,
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    formContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        padding: `${spacing['05']} ${spacing['07']} 28px ${spacing['07']}`,
        gap: 20,
    },
    information: {
        display: 'flex',
        padding: `${spacing['04']} 0`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: spacing['03'],
        flex: '1 0 0',
    },
    name: {
        color: color.content.primary,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '-0.6px',
    },
    paragraph: {
        color: color.content.secondary,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.48px',
    },
    form: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: spacing['03'],
        alignSelf: 'stretch',
    },
    notification: {
        display: 'flex',
        padding: `10px ${spacing['04']}`,
        alignItems: 'flex-start',
        gap: spacing['03'],
        alignSelf: 'stretch',
        borderRadius: radius.overall,
        background: color.background.lightWarning,
    },
    additional: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: spacing['03'],
        alignSelf: 'stretch',
    },
    formText: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 6,
        flex: '1 0 0',
    },
    action: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: 10,
        alignSelf: 'stretch',
        width: 96,
        '& button': {
            height: 44,
            width: '100%',
        },
    },
    inputLabel: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.42px',
    },
    input: {
        width: 440,
        '& input': {
            height: 44,
        },
    },
    cards: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: spacing['03'],
        alignSelf: 'stretch',
    },
    card: {
        padding: `${spacing['04']} ${spacing['05']}`,
        '& svg': {
            width: 24,
            height: 24,
        },
        '& div': {
            fontWeight: 600,
        },
    },
    wcSuccess: {
        display: 'flex',
        padding: `${spacing['06']} ${spacing['07']}`,
        alignItems: 'flex-start',
        gap: spacing['07'],
        alignSelf: 'stretch',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.accent}`,
        background: color.background.lightAccent,
    },
    frame: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: spacing['03'],
        flex: '1 0 0',
    },
    message: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
        flex: '1 0 0',
    },
    messageTitle: {
        textOverflow: 'ellipsis',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '-0.48px',
    },
    messageText: {
        color: color.content.secondary,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.42px',
    },
});
